import { Injectable } from '@angular/core';
import { BaseApiService } from '../base-api.service';
import { CreateProductDto, Product, UpdateProductDto } from '../../../../models/product';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ProductService extends BaseApiService<Product, CreateProductDto, UpdateProductDto> {
  constructor(http: HttpClient) {
    super(http);
    this.resourcePath = 'products';
  }
}
